import { faUser } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { T } from "@repo/transifex";

type ProfileBadgeProps = {
  name: string;
  onLogout: () => void;
};

export const ProfileBadge = ({ name, onLogout }: ProfileBadgeProps) => {
  return (
    <div className="flex items-center gap-3 rounded-full bg-interface-neutral-2 p-1 pl-4">
      <FontAwesomeIcon icon={faUser} size="lg" />

      <p className="text-lg font-semibold">{name}</p>

      <button
        type="button"
        onClick={onLogout}
        className="rounded-full border border-interface-neutral-3 bg-interface-neutral-0 p-3 font-bold text-interface-neutral-5 hover:bg-interface-neutral-2"
      >
        <T _str="Log out" />
      </button>
    </div>
  );
};
